import React from 'react';
import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import FeatherIcon from 'feather-icons-react';
import {CHART_COLORS} from '../../utils/chartColors';

const UsersByRoleBarChart = ({data}) => {
  if (!data || data.length === 0) {
    return (
      <div className="empty-results mt-5">
        <FeatherIcon icon="info"/>
        <div className="empty-results-text">No role data available</div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={360}>
      <BarChart data={data} margin={{top: 8, right: 16, left: 0, bottom: 8}}>
        <CartesianGrid strokeDasharray="3 3" vertical={false}/>
        <XAxis dataKey="roleName" interval={0} angle={-20} textAnchor="end" height={60} tick={{fontSize: 11}}/>
        <YAxis allowDecimals={false} tick={{fontSize: 11}}/>
        <Tooltip contentStyle={{fontSize: 12}} labelStyle={{fontWeight: 600}}/>
        <Legend wrapperStyle={{fontSize: 12}}/>
        <Bar dataKey="total" name="Total Users" fill={CHART_COLORS.primary} radius={[4, 4, 0, 0]}/>
        <Bar dataKey="active" name="Active Users" fill={CHART_COLORS.bluishGray} radius={[4, 4, 0, 0]}/>
        <Bar dataKey="loggedInToday" name="Logged In Today" fill={CHART_COLORS.highlight} radius={[4, 4, 0, 0]}/>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default UsersByRoleBarChart;
